import { WahooMfeOutlet } from "@WahooFitness/wahoo-offline-mfe";

function RouteWrapper() {
  return <WahooMfeOutlet maxWidth={false} />;
}

export default RouteWrapper;
